/**
 * 与后端 PrintFieldEnum 对齐的销售单针式打印字段元数据（fieldCode / fieldName / fieldGroup / required 等）
 * fieldGroup: HEADER | PRODUCT | AMOUNT | FOOTER（TITLE、HEADER_IMAGE、CUSTOM、QR 由页面单独处理）
 */

export const PRINT_FIELD_GROUP = {
  HEADER: 'HEADER',
  PRODUCT: 'PRODUCT',
  AMOUNT: 'AMOUNT',
  FOOTER: 'FOOTER',
};

/** 头部字段展示顺序 */
export const HEADER_FIELD_ORDER = [
  'todayNo',
  'buyerName',
  'buyerAddress',
  'buyerPhone',
  'deliveryTime',
];

/** 货品相关展示顺序 */
export const PRODUCT_FIELD_ORDER = [
  'productName',
  'saleNumber',
  'unitPrice',
  'goodsAmount',
  'tareWeight',
  'index',
  'packWeight',
  'orderNumber',
  'productionTime',
  'shelfLife',
  'remark',
];

/** 金额相关展示顺序 */
export const AMOUNT_FIELD_ORDER = [
  'basketDesc',
  'totalUppercase',
  'total',
  'extraAmount',
  'chargeOrderFee',
  'discountAmount',
  'basketAmount',
  'paymentAmount',
  'prestoreAmount',
  'beforeCreditAmount',
  'buyerCreditAmount',
];

/** 尾部字段展示顺序 */
export const FOOTER_FIELD_ORDER = [
  'createName',
  'createTime',
  'orderRemark',
  'receiverSign',
  'address',
  'stallTelephone',
  'deliveryMan',
  'deliveryVehicle',
  'outboundTime',
  'arrivalTime',
];

/** @type {Array<{ fieldCode: string, fieldName: string, fieldGroup: string, required: boolean, systemPresetField: boolean, handwritten: boolean }>} */
export const PRINT_SALE_FIELD_META = [
  {
    fieldCode: 'todayNo',
    fieldName: '票号',
    fieldGroup: 'HEADER',
    required: true,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'buyerName',
    fieldName: '客户名称',
    fieldGroup: 'HEADER',
    required: false,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'buyerAddress',
    fieldName: '客户地址',
    fieldGroup: 'HEADER',
    required: false,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'buyerPhone',
    fieldName: '客户联系电话',
    fieldGroup: 'HEADER',
    required: false,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'deliveryTime',
    fieldName: '送达日期',
    fieldGroup: 'HEADER',
    required: false,
    systemPresetField: true,
    handwritten: false,
  },

  {
    fieldCode: 'index',
    fieldName: '序号',
    fieldGroup: 'PRODUCT',
    required: false,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'productName',
    fieldName: '品名',
    fieldGroup: 'PRODUCT',
    required: true,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'packWeight',
    fieldName: '规格',
    fieldGroup: 'PRODUCT',
    required: false,
    systemPresetField: false,
    handwritten: false,
  },
  {
    fieldCode: 'orderNumber',
    fieldName: '下单量',
    fieldGroup: 'PRODUCT',
    required: false,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'saleNumber',
    fieldName: '销量',
    fieldGroup: 'PRODUCT',
    required: true,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'unitPrice',
    fieldName: '单价（元）',
    fieldGroup: 'PRODUCT',
    required: true,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'goodsAmount',
    fieldName: '金额（元）',
    fieldGroup: 'PRODUCT',
    required: true,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'tareWeight',
    fieldName: '去皮',
    fieldGroup: 'PRODUCT',
    required: true,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'productionTime',
    fieldName: '生产日期',
    fieldGroup: 'PRODUCT',
    required: false,
    systemPresetField: false,
    handwritten: true,
  },
  {
    fieldCode: 'shelfLife',
    fieldName: '保质期',
    fieldGroup: 'PRODUCT',
    required: false,
    systemPresetField: false,
    handwritten: true,
  },
  {
    fieldCode: 'remark',
    fieldName: '备注',
    fieldGroup: 'PRODUCT',
    required: false,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'basketDesc',
    fieldName: '筐子',
    fieldGroup: 'AMOUNT',
    required: true,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'totalUppercase',
    fieldName: '合计大写',
    fieldGroup: 'AMOUNT',
    required: true,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'total',
    fieldName: '合计小写',
    fieldGroup: 'AMOUNT',
    required: true,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'extraAmount',
    fieldName: '附加费',
    fieldGroup: 'AMOUNT',
    required: false,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'chargeOrderFee',
    fieldName: '三轮车费',
    fieldGroup: 'AMOUNT',
    required: false,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'discountAmount',
    fieldName: '优惠/多收',
    fieldGroup: 'AMOUNT',
    required: false,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'basketAmount',
    fieldName: '收筐',
    fieldGroup: 'AMOUNT',
    required: false,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'paymentAmount',
    fieldName: '实付',
    fieldGroup: 'AMOUNT',
    required: false,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'prestoreAmount',
    fieldName: '预存',
    fieldGroup: 'AMOUNT',
    required: false,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'beforeCreditAmount',
    fieldName: '前欠',
    fieldGroup: 'AMOUNT',
    required: false,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'buyerCreditAmount',
    fieldName: '总欠',
    fieldGroup: 'AMOUNT',
    required: false,
    systemPresetField: true,
    handwritten: false,
  },

  {
    fieldCode: 'orderRemark',
    fieldName: '订单备注',
    fieldGroup: 'FOOTER',
    required: false,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'createName',
    fieldName: '开票员',
    fieldGroup: 'FOOTER',
    required: true,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'createTime',
    fieldName: '开票时间',
    fieldGroup: 'FOOTER',
    required: false,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'receiverSign',
    fieldName: '收货单位&收货人（盖章）',
    fieldGroup: 'FOOTER',
    required: false,
    systemPresetField: true,
    handwritten: true,
  },
  {
    fieldCode: 'address',
    fieldName: '商行地址',
    fieldGroup: 'FOOTER',
    required: false,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'stallTelephone',
    fieldName: '商行联系电话',
    fieldGroup: 'FOOTER',
    required: false,
    systemPresetField: true,
    handwritten: false,
  },
  {
    fieldCode: 'deliveryMan',
    fieldName: '送货人',
    fieldGroup: 'FOOTER',
    required: false,
    systemPresetField: false,
    handwritten: true,
  },
  {
    fieldCode: 'deliveryVehicle',
    fieldName: '送货车型',
    fieldGroup: 'FOOTER',
    required: false,
    systemPresetField: false,
    handwritten: true,
  },
  {
    fieldCode: 'outboundTime',
    fieldName: '出库时间',
    fieldGroup: 'FOOTER',
    required: false,
    systemPresetField: false,
    handwritten: true,
  },
  {
    fieldCode: 'arrivalTime',
    fieldName: '送达时间',
    fieldGroup: 'FOOTER',
    required: false,
    systemPresetField: false,
    handwritten: true,
  },
];

function metaKey(fieldGroup, fieldCode) {
  return `${fieldGroup}:${fieldCode}`;
}

/** 同一 fieldCode 可出现在不同分组时需按分组区分（货品 remark / 尾部 orderRemark） */
const META_BY_GROUP_CODE = new Map(
  PRINT_SALE_FIELD_META.map((f) => [metaKey(f.fieldGroup, f.fieldCode), f]),
);

export function getSaleFieldMeta(fieldCode, fieldGroup) {
  return META_BY_GROUP_CODE.get(metaKey(fieldGroup, fieldCode));
}

export function getOrderedFields(orderArr, fieldGroup) {
  return orderArr.map((code) => getSaleFieldMeta(code, fieldGroup)).filter(Boolean);
}

export function getRequiredCodesInOrder(orderArr, fieldGroup) {
  return orderArr.filter((code) => getSaleFieldMeta(code, fieldGroup)?.required);
}
